import * as React from 'react';

export type BehavioralScoreProps = {
  type: 'GAD7' | 'PHQ9';
  status: string;
  score: number;
};

function BehavioralScore({ type, status, score }: BehavioralScoreProps) {
  return (
    <div
      className={`flex w-fit items-center   py-1 pl-1 pr-5 rounded-full space-x-4 text-[13px] ${
        status === 'Moderately' || status === 'Severe' ? 'bg-[#FFC6BD]' : 'bg-[#FCD8C0]'
      }`}
    >
      <div className="text-poppins bg-[#FFF8ED] px-2 rounded-full ">
        {type} - {score}
      </div>
      <div>{status}</div>
    </div>
  );
}

export default BehavioralScore;
